module.exports = __webpack_public_path__ + "img/sakr.aa85cfbc.png";